export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  AUTH_TOKEN_EXPIRY: 'auth_token_expiry',
  REDIRECT_URL: 'redirect_url',
  IS_GUEST: 'is_guest',
  IS_GUEST_AT: 'is_guest_at',
  RESCHEDULE_APPOINTMENT_ID: 'reschedule_appointment_id',

  CHAIRPERSON_AUTH_TOKEN: 'chairperson_auth_token',
  CHAIRPERSON_AUTH_TOKEN_EXPIRY: 'chairperson_auth_token_expiry',
}
